import { useNavigate } from "react-router-dom";

import { Button } from "antd";

import { IMAGES, ROUTES_URL } from "@/constant";
import styles from "@/pages/NotFound/styles.module.css";
import { useAuthStore } from "@/stores/authStore";

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthStore();
  const onNavigate = (): void => {
    if (isAuthenticated) {
      navigate(ROUTES_URL.DASHBOARD);
    } else {
      navigate(ROUTES_URL.LOGIN);
    }
  };
  return (
    <div className={styles.notFoundWrapper}>
      <img src={IMAGES.TOP_CORNER_404} className={styles.topImage} />
      <img src={IMAGES.BOTTOM_CORNER_404} className={styles.bottomImage} />
      <div>
        <div className={styles.innerImageWrapper}>
          <img src={IMAGES.IMAGE_404} alt="404 Not Found" className={styles.innerImage} />
          <p className={styles.wrapper404}>404</p>
          <p className={styles.title}>Page Not Found</p>
        </div>
      </div>
      <div className={styles.description}>
        The page you’re looking for doesn’t exist or has been moved.
        <br />
        <p> Please check the URL or return to the homepage.</p>
      </div>
      <div className={styles.buttonWrapper}>
        <Button className={styles.homeButton} onClick={onNavigate}>
          Go to Home
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
